'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherCheck, FeatherMail } from '@subframe/core';
interface EtapaSegundoPlanoProps {
  emailDeAviso: string;
  /** ZIP: o e-mail fala das partes, e não de um arquivo só. */
  emPartes: boolean;
}

/**
 * Sem previsão de minutos: o servidor não a informa, e a estimativa de antes vinha do tamanho de
 * um catálogo de seções fixo.
 */
export function EtapaSegundoPlano(t0) {
  const $ = _c(12);
  const {
    emailDeAviso,
    emPartes
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FeatherMail className="text-info-700 mt-px h-[17px] w-[17px] flex-none" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="text-info-700 text-[13.5px] font-semibold">Estamos montando o pacote em segundo plano</span>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = emPartes ? "as partes estiverem prontas" : "o arquivo estiver pronto";
  let t4;
  if ($[2] !== t3) {
    t4 = <div className="border-info-200 bg-info-50 flex items-start gap-3 rounded-[12px] border border-solid px-[18px] py-4">{t1}<div className="flex flex-col gap-[3px]">{t2}<span className="text-info-700 text-[12.5px] leading-[1.6]">Avisamos por e-mail quando{" "}{t3}.</span></div></div>;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== emailDeAviso) {
    t5 = <GarantiaDoJob>Você recebe um e-mail em {emailDeAviso} quando terminar</GarantiaDoJob>;
    $[4] = emailDeAviso;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <GarantiaDoJob>Pode continuar trabalhando no processo enquanto isso</GarantiaDoJob>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t5) {
    t7 = <div className="flex flex-col gap-2.5 rounded-[12px] bg-neutral-50 px-[18px] py-4">{t5}{t6}</div>;
    $[7] = t5;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t4 || $[10] !== t7) {
    t8 = <div className="flex w-full flex-col gap-[18px] px-6 pt-1 pb-6">{t4}{t7}</div>;
    $[9] = t4;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
}
function GarantiaDoJob(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FeatherCheck className="text-success-600 h-[15px] w-[15px] flex-none" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <div className="flex items-center gap-2.5 text-[13px] text-neutral-700">{t1}{children}</div>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}